import { MutationOptions, useMutation } from '@tanstack/react-query';
import { getCSRF } from '../csrf/csrf-resolver';

const url = 'api/salesforce/clickandreserve';

export type ClickAndReservePayload = {
    firstName: string;
    lastName: string;
    fullName: string;
    phoneNumber: string;
    quantity: number;
    storeId: string;
    storeUrl: string;
    productId: string;
    email: string;
};

type ClickAndReserveResponse = {
    reservationNumber: string;
};

const submitForm = async (payload: ClickAndReservePayload): Promise<ClickAndReserveResponse> => {
    const {
        csrf: { token },
    } = await getCSRF();
    const response = await fetch(url + '?csrf_token=' + token, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (data.error) {
        throw new Error(data.errorMessage);
    }
    return data as ClickAndReserveResponse;
};

export const useSubmitClickAndReserve = (
    options?: MutationOptions<ClickAndReserveResponse, Error, ClickAndReservePayload>,
) => {
    return useMutation({
        mutationKey: ['clickAndReserve'],
        mutationFn: submitForm,
        ...options,
    });
};
